import { type Common } from '../common.js';
import type {
  BaseHumanTaskCategory,
  HumanTaskCategory,
  HumanTaskCategoryBasic,
  HumanTaskCategoryQueryParams,
} from '../models/flow/humanTask/humanTaskCategory.js';

export class API {
  common: Common;
  baseEndpoint = '/flow/human-task-categories';

  constructor(common: Common) {
    this.common = common;
  }

  async findAll(queryParams?: HumanTaskCategoryQueryParams): Promise<HumanTaskCategory[]> {
    const url = this.common.constructPath(this.baseEndpoint, queryParams);
    return await this.common.getJSON(url);
  }

  async findAllBasic(
    queryParams?: HumanTaskCategoryQueryParams
  ): Promise<HumanTaskCategoryBasic[]> {
    const url = this.common.constructPath(`${this.baseEndpoint}/basic`, queryParams);
    return await this.common.getJSON(url);
  }

  async findOneById(humanTaskId: string): Promise<HumanTaskCategory> {
    const url = this.common.constructPath(`${this.baseEndpoint}/${humanTaskId}`);
    return await this.common.getJSON(url);
  }

  async findOneByIdBasic(humanTaskId: string): Promise<HumanTaskCategoryBasic> {
    const url = this.common.constructPath(`${this.baseEndpoint}/${humanTaskId}/basic`);
    return await this.common.getJSON(url);
  }

  async create(values: BaseHumanTaskCategory): Promise<HumanTaskCategory> {
    const url = this.common.constructPath(this.baseEndpoint);
    return await this.common.postJSON(url, values);
  }

  async update(id: string, values: BaseHumanTaskCategory): Promise<HumanTaskCategory> {
    const url = this.common.constructPath(`${this.baseEndpoint}/${id}`);
    return await this.common.patchJSON(url, values);
  }

  async delete(id: string): Promise<HumanTaskCategory> {
    const url = this.common.constructPath(`${this.baseEndpoint}/${id}`);
    return await this.common.deleteJSON(url);
  }
}
